

































import Vue from 'vue'
import TitleName from '../atoms/TitleName.vue'
import FaqForTensakuVisiter from '../../utils/FaqForTensakuVisiter'

interface listItem {
  id: number
  topName: string
  question: string
  answer: string
}

export type DataType = {
  titleName: string
  showContent: boolean
  showSubmit: boolean
  showImage: boolean
  showImagePath: string | null
  width: number | null
  examId: string | null
  lists: Array<listItem>
}
export default Vue.extend({
  components: {
    TitleName,
  },
  data(): DataType {
    return {
      titleName: 'よくある質問',
      showContent: false,
      showSubmit: false,
      showImage: false,
      showImagePath: null,
      width: null,
      examId: null,
      lists: []
    }
  },
  created() {
    this.$store.commit('SET_EXAM_INFO', { examInfo: null })
    const examKey = this.$route.params['exam_id']
    if (Object.keys(FaqForTensakuVisiter).includes(examKey)) {
      this.lists = FaqForTensakuVisiter[examKey]
      this.examId = examKey
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  computed:{
    listItem(): listItem | undefined {
      return this.lists.find(list => list.id === parseInt(this.$route.params.id))
    },
    displayForMember(): boolean {
      return this.$store.state.displayForMember
    },
    envCheckUrl() {
      return `${process.env.VUE_APP_ROOT_PATH}/participant/device/`
    }
  },
  methods: {
    handleResize(): void {
      this.width = window.innerWidth;
    }
  }
})
